export default __webpack_public_path__ + "static/media/01.57b8f7bb.jpg";